const getImageSrcByBase64= (buffer) => {
    return `data:image/png;base64, ${buffer}`
}

export default {
    getImageSrcByBase64
}